import React, {useEffect} from 'react'
import {Route, withRouter, Redirect} from 'react-router-dom'
import classNames from 'classnames'
//State
import {useSelector} from 'react-redux'
// Components
import {Grid, Sticky} from 'semantic-ui-react'
import SidebarMenu from './SidebarMenu'
import TopBarLeft from './TopBarLeft'
import TopBarRight from './TopBarRight'
import styles from './styles.module.scss'

const AppLayout = withRouter(({children, match, history}) => {

  const {currentAppId} = useSelector(state => state.applications)
  const isAppsScreen = () => currentAppId && match.url.includes('applications')

  if(!localStorage.getItem('token'))  return <Redirect to='/' />
  const logout = () => {
    localStorage.removeItem("token")
    history.push('/')
  }


  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Grid className={styles.root} stackable>
      <Grid.Row className={styles.pb}>
        <Grid.Column width={3} className={styles.sidebar}>
          <SidebarMenu />
        </Grid.Column>
        <Grid.Column width={13} className={classNames(styles.page, {[styles.builder]: isAppsScreen() })}>
          <Sticky>
            <div className={classNames(styles.topbar, {[styles.builder]: isAppsScreen() })}>
              <Grid>
                <Grid.Column width={12}>
                  <TopBarLeft />
                </Grid.Column>
                <Grid.Column width={4} textAlign="right">
                  <TopBarRight logout={logout}/>
                </Grid.Column>
              </Grid>
            </div>
          </Sticky>
          <div className={styles.content}>
            {children}
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
})



const AppLayoutRoute = ({component: Component, ...rest}) => (
  <Route {...rest} render={props => (
    <AppLayout>
      <Component {...props} />
    </AppLayout>
  )} />
)

export default AppLayoutRoute;